import {styled, theme} from "@reside/ui";

export const FilterContainer = styled.div<{
  isActive: boolean;
  disabled?: boolean;
}>`
  height: 32px;
  border: 1px solid
    ${({isActive, disabled}) =>
      disabled
        ? theme.colors.darkBlue30
        : isActive
        ? theme.colors.primary
        : theme.colors.borderGray};
  border-radius: 30px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  cursor: ${({disabled}) => (disabled ? "default" : "pointer")};
  user-select: none;
  opacity: ${({disabled}) => (disabled ? 0.5 : 1)};

  // Default (inactive) state - grayed out
  background-color: ${({isActive, disabled}) =>
    disabled ? "transparent" : isActive ? theme.colors.primary : "transparent"};
  color: ${({isActive, disabled}) =>
    disabled
      ? theme.colors.darkBlue60
      : isActive
      ? theme.colors.white
      : theme.colors.darkBlue100};

  // Icon styling
  .star-icon {
    display: ${({isActive}) => (isActive ? "none" : "block")};
    fill: ${({disabled}) =>
      disabled ? theme.colors.darkBlue60 : theme.colors.darkBlue100} !important;
    color: ${({disabled}) =>
      disabled ? theme.colors.darkBlue60 : theme.colors.darkBlue100} !important;
  }

  .star-icon-filled {
    display: ${({isActive}) => (isActive ? "block" : "none")};
    fill: ${({isActive, disabled}) =>
      disabled
        ? theme.colors.darkBlue60
        : isActive
        ? theme.colors.golden90
        : theme.colors.darkBlue100} !important;
    color: ${({isActive, disabled}) =>
      disabled
        ? theme.colors.darkBlue60
        : isActive
        ? theme.colors.golden90
        : theme.colors.darkBlue100} !important;
  }

  // Text styling
  p {
    color: ${({isActive, disabled}) =>
      disabled
        ? theme.colors.darkBlue60
        : isActive
        ? theme.colors.white
        : theme.colors.darkBlue100} !important;
  }

  // Hover effects
  &:hover:not([disabled]) {
    background-color: ${({disabled}) =>
      disabled ? "transparent" : theme.colors.primary};
    border-color: ${({disabled}) =>
      disabled ? theme.colors.darkBlue60 : theme.colors.primary};
    color: ${({disabled}) => (disabled ? theme.colors.darkBlue60 : "white")};

    .star-icon {
      display: ${({disabled}) => (disabled ? "block" : "none")};
    }

    .star-icon-filled {
      display: ${({disabled}) => (disabled ? "none" : "block")};
      fill: ${({disabled}) =>
        disabled ? theme.colors.darkBlue60 : theme.colors.golden90} !important;
      color: ${({disabled}) =>
        disabled ? theme.colors.darkBlue60 : theme.colors.golden90} !important;
    }

    p {
      color: ${({disabled}) =>
        disabled ? theme.colors.darkBlue60 : "white"} !important;
    }
  }

  .clear-icon {
    &:before {
      font-weight: bold !important;
    }
    margin-left: 8px;
  }
`;
